import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserProfile } from "../../../user-profile/user-profile.thunks";
import { ShopCartUrlContext } from "../../../../common/utils/cart-util";
import { waitForUser } from "../../../../store/store";
import { StoreState } from "../../../../store/store.interface";
import { getShareCartMergeApiCallMagento } from "../api/shop-cart.api";
import { getPromoCode } from "../../../promo-code/promo-code.selectors";
import { updatePromoCode } from "./update-promo-code.thunk";
import { getZipCode } from "../../../estimated-tax/estimated-tax.selectors";
import { getEstimatedTax } from "../../../estimated-tax/estimated-tax.thunks";
import { ActionStatus } from "../../../../common/constants/action-status";

export const mergeShareCart = createAsyncThunk('mergesharecart/mergeCart', async (shopCartUrlContext: ShopCartUrlContext, thunkAPI) => {
    try {
      thunkAPI.dispatch(fetchUserProfile());
      await waitForUser();
      const state = thunkAPI.getState() as StoreState;
      return await getShareCartMergeApiCallMagento(state, shopCartUrlContext);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    } finally {
      const state = thunkAPI.getState() as StoreState;
  
      // If we have already found a promo code, update it after the quantity changes
      const promoCode = getPromoCode(state);
      if (promoCode) {
        thunkAPI.dispatch(updatePromoCode({ promoCode, forceUpdate: true }));
      }
  
      // If we have already found an estimated tax, update it after the quantity changes
      const zipCode = getZipCode(state);
      if (zipCode) {
        thunkAPI.dispatch(getEstimatedTax({ zipCode }));
      }
    }
  }, {
    condition: ((_arg, { getState }) => {
      const state = getState() as StoreState;
      if (state.shopCartState.mergeSharedCart.status == ActionStatus.loading || state.shopCartState.mergeSharedCart.status == ActionStatus.succeeded) {
        return false;
      }
      return true;
    })
  });